import { useState } from 'react'
import PluginsImagePreviewSlider from './PluginsImagePreviewSlider'
import { useTranslation } from 'next-i18next'
import Image from 'next/future/image'
import Zoom from '../icons/Zoom'

export default function PluginsImagePreview ({ medias, videoLink }) {
  const { t } = useTranslation(['plugins'])
  const [showSlider, setShowSlider] = useState(false)
  const [selectedMedia, setSelectedMedia] = useState(0)

  const handleSliderChange = (index) => {
    setShowSlider(true)
    setSelectedMedia(index)
  }

  function MediaPreview () {
    /**
     * We only want to display a total of 3. This includes the video, too.
     * @type {number}
     */
    const displayLimit = 3
    /**
     * Here we have to decide how many images we can display. If we have a video, we can only display 2 images.
     * @type {number}
     */
    const mediaLimit = videoLink ? 2 : 3
    const totalMedias = medias.length + (videoLink ? 1 : 0)
    const mediasToDisplay = [...medias].slice(0, mediaLimit)

    return (
      <>
        {
          videoLink && (
            <div className="col-12 col-md-4 position-relative imagepreviewitem">
              <iframe
                width="560"
                height="315"
                src={videoLink.startsWith('https://www.youtube.com')
                  ? videoLink.replace('watch?v=', 'embed/')
                  : videoLink.replace('vimeo.com', 'player.vimeo.com/video')}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-100 h-100 fit-cover"
              >
              </iframe>
              {
                totalMedias <= displayLimit && (
                  <button
                    className="btn btn-sm ms-4 mb-3 position-absolute bottom-0 start-0 imagepreviewitem__zoombutton"
                    onClick={() => handleSliderChange(0)}
                  >
                    <Zoom />
                  </button>
                )
              }
            </div>
          )
        }
        {
          mediasToDisplay.map((media, index) => (
            (
              <div
                className="col-12 col-md-4 position-relative imagepreviewitem"
                key={media.id}
              >
                {
                  media.media.url && (
                    <Image
                      src={media.media.url}
                      alt=""
                      width={media.media.width}
                      height={media.media.height}
                      className="w-100 h-100 fit-cover"
                    />
                  )
                }
                {
                  (index === mediasToDisplay.length - 1 && totalMedias > displayLimit) && (
                    <button
                      className="text-uppercase btn btn-light me-4 mb-3 position-absolute bottom-0 end-0"
                      onClick={() => handleSliderChange(0)}
                    >
                      {t('detail.view_all_screenshots')}
                    </button>
                  )
                }
                {
                  totalMedias <= displayLimit && (
                    <button
                      className="btn btn-sm ms-4 mb-3 position-absolute bottom-0 start-0 imagepreviewitem__zoombutton"
                      onClick={() => handleSliderChange(videoLink ? index + 1 : index)}
                    >
                      <Zoom />
                    </button>
                  )
                }
              </div>
            )
          ))
        }
      </>
    )
  }

  return (
    <>
      {
        (medias.length > 0 || videoLink) && (
          <div>
            <div className="col-12">
              <div className="row g-3 position-relative">
                {
                  MediaPreview()
                }
              </div>
              <div className="row justify-content-center d-flex d-md-none">
                <div className="col-auto">
                  <button
                    className="btn btn-outline-primary mt-3 btn-sm"
                    onClick={() => setShowSlider(true)}
                  >
                    {t('detail.view_all_screenshots')}
                  </button>
                </div>
              </div>
            </div>
            {
              showSlider && (
                <PluginsImagePreviewSlider
                  start={selectedMedia}
                  onHide={setShowSlider}
                  medias={medias}
                  videoLink={videoLink}
                />
              )
            }
          </div>
        )
      }
    </>
  )
}
